import './style.css';

import { memo } from 'react';

import { merge } from '@/components';
import { Flex, Heading, Text } from '@/components/core';
import { DivProps } from '@/utils';

type LoadingIndicatorProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'plain' | 'primary' | 'secondary';
};

const ILoadingIndicator = ({ variant, size = 'sm' }: LoadingIndicatorProps) => {
  const plainStyles = 'bg-black';
  const primaryStyles = 'bg-primary-400';
  const secondaryStyles = 'bg-gray-300';

  const styles = {
    plain: plainStyles,
    primary: primaryStyles,
    secondary: secondaryStyles,
  }[variant ?? 'plain'];

  return (
    <div
      className={`size-${size} flex h-[calc(var(--loader-sz)*1.5)] w-[calc(var(--loader-sz)*1.5)] items-center justify-center`}
    >
      <div className="loader">
        <div className={`circle ${styles}`} />
        <div className={`circle ${styles}`} />
        <div className={`circle ${styles}`} />
        <div className={`circle ${styles}`} />
      </div>
    </div>
  );
};

export const LoadingIndicator = memo(ILoadingIndicator) as typeof ILoadingIndicator;

export type LoadingProps = DivProps &
  LoadingIndicatorProps & {
    label?: string;
    message?: string;
  };

const ILoading = ({ className, label, variant, children, message, size, ...rest }: LoadingProps) => {
  return (
    <Flex col className={merge('gap-sm h-full w-full items-center justify-center', className)} {...rest}>
      <LoadingIndicator size={size} variant={variant} />

      {children ?? (
        <Flex col className="bg-transparent">
          <Heading size={size}>{label}</Heading>
          {message ? <Text>{message}</Text> : null}
        </Flex>
      )}
    </Flex>
  );
};

export const Loading = memo(ILoading) as typeof ILoading;
